import React, { useEffect, useState } from 'react';
import RCSlider from 'rc-slider';
import { mapValues } from 'lodash';

import { usePrevious } from '../../../core/hooks/usePrevious';

import 'rc-slider/assets/index.css';
import './RangeSlider.scss';

const trackStyle = [
  {
    backgroundColor: '#3156EC',
    boxShadow: '0px 0px 4px #B5C4FF'
  }
];

const railStyle = {
  height: '3px',
  backgroundColor: '#CDCEC8'
};

const handleStyle = {
  backgroundColor: '#3156EC',
  border: 'none'
};

const activeDotStyle = {
  backgroundColor: 'black'
};

interface Props {
  marks?: Record<number, React.ReactNode | { style?: React.CSSProperties | undefined; label?: string | undefined }> | undefined;
  min?: number;
  max?: number;
  step?: number;
  defaultValue?: number[];
  firstMax: number;
  secondMin: number;
  value?: number[];
  onChange?: (changeValue: number[]) => void;
}

const RangeSlider: React.FC<Props> = ({ marks, min, max, step, defaultValue, firstMax, secondMin, onChange, value }) => {
  const [defaultMin, defaultMax] = defaultValue ?? [];
  const [currentValue, setCurrentValue] = useState([defaultMin ?? 0, defaultMax ?? 1]);
  const prevValue = usePrevious(value);

  useEffect(() => {
    if (value && prevValue !== value) {
      setCurrentValue(value);
    }
  }, [prevValue, value]);

  const extendedMarks = mapValues(marks, (item, key) => {
    const isSelected = !!currentValue.find((val) => val === Number(key));
    return (
      <div className={`range-slider__mark ${isSelected ? 'range-slider__mark--is-selected' : ''}`}>
        <span className="range-slider__mark-dot" />
        {item}
      </div>
    );
  });

  const handleChange = (changeValue: number[]) => {
    const [firstChangeValue, secondChangeValue] = changeValue;

    if (secondChangeValue - firstChangeValue >= 0.5 && firstChangeValue <= firstMax && secondChangeValue >= secondMin) {
      setCurrentValue(changeValue);

      if (onChange) {
        onChange(changeValue);
      }
    }
  };

  return (
    <div className="range-slider">
      <RCSlider.Range
        value={value}
        onChange={handleChange}
        trackStyle={trackStyle}
        railStyle={railStyle}
        handleStyle={[handleStyle, handleStyle]}
        activeDotStyle={activeDotStyle}
        min={min}
        max={max}
        step={step}
        defaultValue={defaultValue}
        marks={extendedMarks}
        allowCross={false}
      />
    </div>
  );
};

export default RangeSlider;
